export const routesFixedToken: string[] = [
  'api/Master/countries',
  'api/Master/departments',
  'api/Master/cities',
  'api/Master/department-cities',
  'api/Master/identification-types',
  'api/Master/civil-status',
  'api/Master/blood-groups',
  'api/Master/genders',
  'api/Master/street-letters',
  'api/Master/street-routes',
  'api/Master/street-routes-designations',
  'api/Master/housing-types',
  'api/Master/academic-levels',
  'api/Master/client-document-types',
  'api/RequisitionCandidates/info-candidate',
  'api/Person/data-basic',
  'api/PersonAcademic/by-id',
  'api/PersonAcademic/delete',
  'api/PersonAcademic/create-full',
  'api/PersonAcademic/update-full',
  'api/PersonWorking/by-id',
  'api/PersonWorking/delete',
  'api/PersonWorking/create-full',
  'api/PersonWorking/update-full',
  'api/Person/upload-file',
  'api/PersonDocuments/upload-file',
  'api/PersonDocuments/documents',
  'api/PersonDocuments/documents-process',
  'api/PersonDocuments/document-by-id',
  'api/PersonDocuments',
  'api/RequisitionCandidates/finalice-process-candidate',
  'api/Master/parentesco',
  'api/Master/pension-list',
  'api/Master/health-list',
  'api/Person/confirm-pre-register',
  'api/Person/correction-identification',
  'api/Master/genders-info-candidate',
  'api/Master/economic-levels',
  'api/InfoCandidateStage/info-candidate-stage',
  'api/PersonVehicle',
  'api/Master/vehicle-types',
  'api/RegistroPublico/persona',
  'api/Master/format-address',
];
